import React, { createContext, useState } from "react";

export let HidepopupContext = createContext();

export default function Hidepopup({ children }) {
  let [hidePopUp, setHidePopUp] = useState(true);
  return (
    <HidepopupContext.Provider value={{ hidePopUp, setHidePopUp }}>
      {children}
    </HidepopupContext.Provider>
  );
}
